













































































































import BaseComponent from '@/components/base-component.vue';
import PatientForm from '@/components/patients/patient-form.vue';
import InputMoney from '@/components/UI/input-money.vue';
import LockChildren from '@/components/UI/lock-children.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { toNumber } from '@/helpers/toNumber';
import IPatient from '@/interfaces/patient';
import { PrescricaoParmDTO } from '@/interfaces/prescription';
import { TranscricaoOcrResult } from '@/interfaces/transcricao-ocr';
import PatientModel from '@/models/patient-model';
import { checkUserPermissions } from '@/services/auth';
import { calculateImc, getPatientCaloricWeight } from '@/services/patients';
import * as service from '@/services/prescription';
import {
  GENDERS, PATIENT_NEWBORN_TYPES, PATIENT_TYPES
} from '@/settings/consts/patient';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import * as dialog from '@/subjects/dialog';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';


@Component({
  components: {
    PermissionAuth,
    InputMoney,
    PatientForm,
    LockChildren,
  },
})
export default class PrescriptionFormPatient extends BaseComponent {
  @Prop()
  public item;
  @Prop()
  public copyItem;
  @Prop()
  public disabled?: boolean;
  @Prop()
  public lockPatient?: boolean;
  @Prop()
  public receivedCaloricWeight: number;
  @Prop()
  public ocr: TranscricaoOcrResult;
  @Prop()
  public draft: PrescricaoParmDTO;
  @Prop()
  public patientHeight: number;

  public status:boolean = true;
  public imc: any  = null;

  public alertTitle: string = 'Alterar Paciente?';
  public alertMessage: string =
    'Ao alterar, as informações de Tipo de Prescrição, Dados de Entrega, Dados Complementares e Produtos serão perdidas.';

  public patientLocked: boolean = false;

  public rules: any = {
    paciente: [(v) => (!!v && !!v.id) || 'Selecione um paciente'],
    peso: [
      (v) => !!v || 'Digite o peso do paciente',
      (v) => toNumber(v) > 0 || 'O peso deve ser maior que 0',
    ],
  };

  public formPatientOpen: boolean = false;
  public patient: PatientModel = new PatientModel();

  public patientLoading: boolean = false;
  public patients: IPatient[] = [];
  public patientTypes: any = {};
  public patientNewbornTypes: any = {};
  public genders: any = [];
  public caloricWeight: boolean = false;
  public loadingWeight: boolean = false;
  idPatientEdit = null;
  weight = null;

  @Watch('receivedCaloricWeight')
  public onChangeReceivedCaloricWeight(val: any): void {
    let usoPesoCalorico = val != null;
    if (usoPesoCalorico == this.caloricWeight) {
      return;
    }
    setTimeout(() => {
      this.caloricWeight = usoPesoCalorico;
      this.onCaloricWeightChange(this.caloricWeight);
    }, 200);
  }

  @Watch('item.paciente')
  public onChangePacienteId(paciente: any): void {
    if (this.item.idPrescricao && this.item.paciente) {
      this.item.paciente.completo = true;
    }
    if (!!paciente) {
      this.weight = paciente.peso;
    }
  }

  @Watch('item.unidade')
  public onChangeItem(val: any): void {
    this.loadPatients();
  }

  @Watch('status')
  public onChangeStatus(val: any): void {
    this.loadPatients();
  }

  @Watch('lockPatient')
  public onChangeLockPatient(val: boolean): void {
    this.patientLocked = val;
  }

  @Watch('patientLocked')
  public onChangePatientLocked(val: boolean): void {
    if (!!val) {
      return;
    }
    this.$emit('unlockPatient');
  }

  @Watch('ocr')
  public onChangeOcr(ocr: TranscricaoOcrResult): void {    
    if (!ocr || !ocr.idPaciente) {
      return;
    }
    
    this.loadWhenReady(ocr.idPaciente, ocr.pesoPaciente, ocr.pesoCalorico)
  }

  @Watch('draft')
  public onDraftChange(dto: PrescricaoParmDTO): void {    
    if (!dto || !dto.idPaciente) {
      return;
    }
    
    this.loadWhenReady(dto.idPaciente, dto.pesoPaciente, dto.usoPesoCalorico)
  }


  loadWhenReady(idPaciente, pesoPaciente, pesoCalorico) {
    if (!idPaciente) {
      this.onChangePatient(new PatientModel());
      return;
    }
    this.sleepUntil(() => {
      return this.patients && this.patients.length;
    }, 120000).then(() => {
      this.item.paciente = this.patients.find((p) => Number(p.id) == idPaciente);
      this.onChangePatient(this.item.paciente);
      if (pesoPaciente && Number(this.item.paciente.peso) != pesoPaciente) {
        this.sleepUntil(() => {
          return this.item.paciente && this.item.paciente.completo
        }, 120000).then(() => {
          this.item.paciente.peso = pesoPaciente;
          this.onChangeWeight(this.item.paciente.peso);
        });
      }
    });
    if (pesoCalorico != null) {
      this.sleepUntil(() => {
        return this.item.paciente && this.item.paciente.completo;
      }, 180000).then(() => {
        if (this.item.paciente.pesoCalorico) {
          this.setCaloricWeightChange(pesoCalorico.valueOf());
        }
      });
    }
  }

  @Watch('copyItem')
  public onChangeCopyItem(copyItem): void {    
    if (!copyItem || !copyItem.paciente || !copyItem.paciente.id) {
      return;
    }    
    this.loadWhenReady(copyItem.paciente.id, null, null);
  }

  public beforeMount(): void {
    this.item.paciente = new PatientModel();
    this.getPatientTypes();
    this.getGenders();
  }

  public onChangeWeight(val): void {
    this.item.paciente.peso = val;
    let pac = this.item.paciente;
    if (!pac.peso) {
      this.$emit('changeWeight', val);
      return;
    }
    this.loadingWeight = true;
    getPatientCaloricWeight(pac.id, this.item.unidade.id, pac.peso).subscribe(pc => {
      this.item.paciente.pesoCalorico = Number(pc);
      this.$emit('changeWeight', val);
      this.loadingWeight = false;
      if (!this.item.paciente.pesoCalorico) {
        this.setCaloricWeightChange(false);
      }
    }, erro => {
      this.$emit('changeWeight', val);
      this.loadingWeight = false;
    });
  }

  public onChangePatient(val): void {
    this.setCaloricWeightChange(false);
    if (!val) {
      this.item.paciente = new PatientModel();
      this.$emit('changePatient', this.item.paciente);
      return;
    }
    
    this.loadPatient(val.id, true);
  }

  public loadPatient(id:number, showActivation: boolean) {
    this.patientLoading = true;
    this.addSubsc(service.getClientPatientDetails(id, this.item.unidade.id).subscribe(p => {
      let patient = this.preparePatient(p);
      if (this.ocr && !!this.ocr.pesoPaciente) {
        patient.peso = this.ocr.pesoPaciente;
      }
      this.item.paciente = patient;
      this.weight = patient.peso;
      this.$emit('changePatient', patient);
      this.patientLoading = false;
      if (!p.ativo && showActivation) {
        this.prepareActivationPatient();
      }
    }, error => {
      this.patientLoading = false;
    }));
  }

  public showPatientButton(): boolean {
    return (
      !this.disabled &&
      !!this.item.unidade &&
      this.item.unidade.cliente &&
      this.item.unidade.qtdeEnderecos
    );
  }

  public getNewPatientButton() {
    if (!this.showPatientButton()) {
      return null;
    }
    if (this.item.paciente && this.item.paciente.id) {
      return checkUserPermissions([PERMISSIONS_KEYS.PATIENT_EDIT]) ? 'edit' : null;
    } else {
      return checkUserPermissions([PERMISSIONS_KEYS.PATIENT_INSERT]) ? 'add_circle_outline' : null;
    }
  }

  public openPatientForm(): void {
    if (this.item.paciente && this.item.paciente.id) {
      this.idPatientEdit = this.item.paciente.id;
    } else {
      this.idPatientEdit = null;
    }
    this.formPatientOpen = true;
  }

  public savePatientItem(patient: PatientModel): void {
    this.closePatientForm();

    if (!patient || !patient.ativo) {
      // para caso salvar um paciente inativado,
      // limpar a seleção de paciente
      this.item.paciente = new PatientModel();
      this.$emit('changePatient', this.item.paciente);
      setTimeout(() => {
        this.loadPatients();
      }, 500);
      return;
    }
    if (!!this.item.unidade && !!this.item.unidade.cliente) {
      if (
        !!patient &&
        patient.unidades.some((item) => item.id === this.item.unidade.id)
      ) {
        this.loadPatients().then(() => {
          const newPatient = this.patients.find((p) => p.id == patient.id);
          this.item.paciente = newPatient;
          this.loadPatient(Number(patient.id), false);
        });
      }
    }
  }

  prepareActivationPatient() {
    if (!this.item.paciente || this.item.paciente.ativo) {
      return;
    }
    this.openPatientForm();
    setTimeout(() => {
      this.dialog.show(
        'alert', 
        'Reative o paciente',
        null,
        'Ok',
        () => {
          
        },
        null,
        null,
        'Paciente desativado.<br>Ative e selecione o endereço para continuar com a prescrição.',
        '450px',
        );      
    }, 1000);
  }

  public closePatientForm(): void {
    this.patient = new PatientModel();
    this.formPatientOpen = false;
    if (this.item.paciente && !this.item.paciente.ativo) {
      this.item.paciente = this.patient;
    }
  }

  private formatDate = (value: string): string => {
    if (value.indexOf('-') > -1) {
      return dateFormat(value);
    }
    return value;
  }

  private loadPatients(): Promise<void> {
    this.patients = [];

    const currentPatient = this.item.paciente;

    return new Promise((res, rej) => {
      if (!this.item.isVisualization() && !this.item.isCopy()) {
        this.item.paciente = new PatientModel();
      }

      if (
        !this.item.unidade ||
        !this.item.unidade.id ||
        !this.item.unidade.cliente
      ) {
        res();
        return;
      }

      if (this.item.isCopy() || this.item.isVisualization()) {
        this.patients.push({
          ...this.item.paciente,
          nascimento: !!this.item.paciente
            ? dateFormat(this.item.paciente)
            : null,
        });
        res();
      } else {
        this.patientLoading = true;
        service.listPrescriptionPatientsCombo(this.item.unidade.id, this.status).subscribe(
          (data) => {
            this.patientLoading = false;
            this.patients = this.patients.concat(
              data.map(this.preparePatient),
            );

            if (!!currentPatient && !!currentPatient.id) {              
              this.loadPatient(currentPatient.id, false);
            } else if (!this.ocr && this.item.transcricao && this.item.transcricao.paciente && this.item.transcricao.paciente.id) {
              if (this.patients.some(p => p.id == this.item.transcricao.paciente.id)) {
                this.loadPatient(this.item.transcricao.paciente.id, false);
              }
            }

            res();
          },
          () => {
            this.patientLoading = false;
            rej();
          },
        );
      }
    });
  }

  private preparePatient(item) {    
    return {
      ...item,
      setor: item.setor || '',
      leito: item.leito || '',
      same: item.same || '',
      termo: item.termo || null,
      idadeAMD: item.idadeAMD || null,                  
      planoSaude: item.planoSaude || null,
      nascimento: !!item.nascimento
        ? dateFormat(item.nascimento)
        : null,
      completo: !!item.tipo
    };
  }

  private getPatientTypes(): void {
    this.patientTypes = PATIENT_TYPES;
    this.patientNewbornTypes = PATIENT_NEWBORN_TYPES;
  }

  private getGenders(): void {
    this.genders = GENDERS;
  }

  private onCaloricWeightChange(val:boolean) {
    setTimeout(() => {      
      if (this.disabled) {
        this.setCaloricWeightChange(val);
        return;
      }
      if (!this.item || !this.item.paciente || !this.item.paciente.pesoCalorico) {
        this.setCaloricWeightChange(false);
        return;
      }     
      dialog.show(
        'alert',
        val? 'Usar Peso Calórico' : 'Não usar Peso Calórico',
        val? 'Utilizar peso calórico para fazer a prescrição?' : 'Cancelar o uso de peso calórico na prescrição?',
        'Concordo',
        () => {
          this.setCaloricWeightChange(val);
        },
        'Discordo',
        () => {
          this.caloricWeight = !val;
        },
        null,
        null
      );    
    }, 100);
  }

  private setCaloricWeightChange(val: boolean) {
    this.caloricWeight = val;
    this.$emit('caloricWeightChange', val);
  }


  @Watch('patientHeight')
  onPatientHeightChange() {
    if (!this.patientHeight) {      
      this.imc = null;
      this.$emit('calcImc', null);
      return;
    }
    calculateImc(this.item.paciente.peso, this.patientHeight).subscribe(
      (res) => {
        this.imc = res;
        this.$emit('calcImc', this.imc);
      },
      (error) => {
        this.showToastApiError(error);
      },
    );
  }
}
